import { render } from "./ReserveDialog.vue?vue&type=template&id=97fb6c92&scoped=true"
import script from "./ReserveDialog.vue?vue&type=script&lang=js"
export * from "./ReserveDialog.vue?vue&type=script&lang=js"

import "./ReserveDialog.vue?vue&type=style&index=0&id=97fb6c92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fb6c92"]])

export default __exports__